/**
 * inCust terminal API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface IncustControllersTermApiFinalizeCheckRequest {
  /**
   * Comment
   */
  comment?: string;
  /**
   * Transaction Id
   */
  id: string;
}
